import React from "react";
import { useState } from "react";

import SubmitButton from "../button/SubmitButton";
import ErrorMessage from "../ErrorMessage";
import SuccessMessage from "../SuccessMessage";

const NewsletterForm = () => {
  const [status, setStatus] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleChange = (e) => setEmail(e.target.value);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (status === "pending") {
      return;
    }

    setStatus("pending");

    fetch(`${process.env.NEXT_PUBLIC_DEFAULT_API_ROOT}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `
          mutation subscribeToNewsletter($email: String!){
            subscribeToNewsletter(email: $email)
          }
        `,
        variables: {
          email,
        },
      }),
    })
      .then(() => {
        setStatus("success");
        setMessage("");
      })
      .catch(() => {
        setStatus("error");
        setMessage("Es gab einen Fehler beim Eintragen Ihrer E-Mail. Bitte versuchen Sie es später erneut.");
      });
  }

  if (status === "success") {
    return (
      <div className="lg:w-4/5 text-center">
        <SuccessMessage>
          Vielen Dank!
          {" "}
          <br />
          Sie haben sich erfolgreich angemeldet!
        </SuccessMessage>
      </div>
    )
  }

  return (
    <>
      <form onSubmit={handleSubmit} className="lg:w-4/5">
        <div className="lg:flex lg:items-center">
          <div className="py-2 lg:mr-2 lg:flex-grow">
            <input
              className="text-lg leading-tight border border-grey-dark w-full rounded-sm pl-2 py-3"
              id="email"
              type="email"
              placeholder="E-Mail-Adresse"
              value={email}
              onChange={handleChange}
              aria-label="Newsletteranmeldung E-Mail-Adresse"
            />
          </div>
          <SubmitButton color="primary" large disabled={status === "pending"}>
            Anmelden
          </SubmitButton>
        </div>
      </form>
      {status === "error" && (
        <div className="lg:w-4/5">
          <ErrorMessage>{message}</ErrorMessage>
        </div>
      )}
    </>
  )
}

export default NewsletterForm;
